import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { PropertiesProvider } from "./properties/PropertiesContext";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import "./i18n";
import "./styles.css";
import "./theme.css";

const storedTheme = localStorage.getItem("xentros.theme");
document.documentElement.setAttribute("data-theme", storedTheme === "dark" ? "dark" : "light");

const isTauri = typeof window !== "undefined" && (window as { __TAURI__?: unknown }).__TAURI__;
const Router = isTauri ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary
      title="Xentros could not start"
      description="A startup error was caught before the workspace could be displayed."
    >
      <AuthProvider>
        <PropertiesProvider>
          <Router>
            <App />
          </Router>
        </PropertiesProvider>
      </AuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
